import React, { useState } from 'react';
import { ClickAwayListener, IconButton, Badge } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { useSelector } from 'react-redux';
import { mdiBellAlertOutline } from '@mdi/js';
import { Notification } from './Notification';
import { CustomWidthTooltip } from './CustomWidthTooltip';
import Icons from '../Icon';

const theme = createTheme({
  palette: {
    primary: {
      main: '#e87400',
    },
    secondary: {
      main: '#383A35',
    },
  },
});

export const Notifications = () => {
  const nomeCorPrincipal = useSelector(
    (state) => state.customizaSistema.nomeCorPrincipal
  );
  const isPlanoA = nomeCorPrincipal === 'gray';
  const color = isPlanoA ? 'secondary' : 'primary';

  const notificationsMock = [
    'Teste de notificação mock',
    'Teste de notificação mock porém com a mensagem bem maior só pra testar se não vai quebrar layout',
    'Teste de notificação mock 2',
  ];

  const nm = notificationsMock.map((n) => ({
    message: n,
    checked: false,
  }));

  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState(nm);
  const [counter, setCounter] = useState(notifications.length);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const markAsRead = (message) => {
    setNotifications((prevNotifications) => {
      const notificationIndex = prevNotifications.findIndex(
        (n) => n.message === message
      );
      const newNotifications = prevNotifications;

      if (notificationIndex !== -1) {
        newNotifications[notificationIndex] = {
          message,
          checked: true,
        };
      }

      return newNotifications;
    });

    setCounter(
      notifications.reduce((acc, next) => {
        return next.checked ? acc - 1 : acc;
      }, notifications.length)
    );
  };

  return (
    <ThemeProvider theme={theme}>
      <ClickAwayListener onClickAway={handleTooltipClose}>
        <div>
          <CustomWidthTooltip
            title={notifications.map(({ message, checked }) => (
              <Notification
                key={message}
                markAsRead={markAsRead}
                message={message}
                checked={checked}
              />
            ))}
            onClose={handleTooltipClose}
            open={open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            placement="bottom-end"
          >
            <IconButton
              aria-label="notificações"
              onClick={() => setOpen((prev) => !prev)}
            >
              <Badge badgeContent={counter} color={color}>
                <Icons path={mdiBellAlertOutline} size={2} />
              </Badge>
            </IconButton>
          </CustomWidthTooltip>
        </div>
      </ClickAwayListener>
    </ThemeProvider>
  );
};
